const SSN_REGEX = /^(\d{3})-(\d{2})-(\d{4})$/;
/**
 * Validates that a value is a valid Social Security Number.
 */
export const Validator = {
    name: "ssn",
    errorMessage: "Entered value is not valid Social Security Number.",
    validate: value => SSN_REGEX.test(`${value}`),
};
